export default {
  START: 'startDate',
  END: 'endDate',
};
